import { OrderApprovalsDataViewContext } from "@insite/client-framework/Store/Data/OrderApprovals/OrderApprovalsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderApprovalListPageContext } from "@insite/content-library/Pages/OrderApprovalListPage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderApprovalResultCountStyles {
    orderCountText?: TypographyPresentationProps;
}

export const resultCountStyles: OrderApprovalResultCountStyles = {
    orderCountText: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
};

const styles = resultCountStyles;

const OrderApprovalResultCount: FC<WidgetProps> = () => {
    const orderApprovalsDataView = useContext(OrderApprovalsDataViewContext);
    if (!orderApprovalsDataView.value || !orderApprovalsDataView.pagination) {
        return null;
    }
    const totalItemCount = orderApprovalsDataView.value
        ? orderApprovalsDataView.pagination
            ? orderApprovalsDataView.pagination.totalItemCount
            : 0
        : undefined;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.orderCountText} data-test-selector="orderApproval_resultCount">
            {orderApprovalsDataView?.pagination?.totalItemCount} {translate("orders")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: OrderApprovalResultCount,
    definition: {
        group: "Order Approval List",
        displayName: "Result Count",
        allowedContexts: [OrderApprovalListPageContext],
    },
};

export default widgetModule;
